import { useEffect, useState } from 'react'

import { sankeyService } from './sankey.service'
import { useTooltipDisplayContext } from '../common/tooltip/tooltip.context'

import { useCommonStyles } from './common.style'

export const SelectedFlows = function ({ sankeyData, selectedSegmentSize }) {
  const commonClasses = useCommonStyles()

  const [svgElements, setSvgElements] = useState([])
  const [focusedFlow, setFocusedFlow] = useState({})
  const [, setTooltipDisplayData] = useTooltipDisplayContext()

  useEffect(() => {
    const flows = []

    sankeyData.iterateThroughSelectedFlows(function (flow, stage, fromState, toState, demographicValue) {
      let isFocusedFlow = false

      if (focusedFlow.stage === stage && focusedFlow.fromState === fromState && focusedFlow.toState === toState && focusedFlow.demographicValue === demographicValue) {
        isFocusedFlow = true
      }

      flows.push(
        <path key={`sf-${stage}-${fromState}-${toState}-${demographicValue}`}
          d={sankeyService.generatePath(flow)}
          className={`${isFocusedFlow ? commonClasses.highlight : commonClasses.flow}`}
          onMouseOver={() => { handleMouseOver(flow, stage, fromState, toState, demographicValue) }}
          onMouseOut={handleMouseOut} />
      )
    })

    setSvgElements(flows)
  }, [sankeyData, focusedFlow])

  function handleMouseOver (flow, stage, fromState, toState, demographicValue) {
    setFocusedFlow({ stage, fromState, toState, demographicValue })

    setTooltipDisplayData(
      sankeyService.getFlowTooltipDisplayObject({
        fromStateName: sankeyData.layout.stateLabels[fromState],
        toStateName: sankeyData.layout.stateLabels[toState],
        value: flow.size,
        denominator: selectedSegmentSize
      })
    )
  }

  function handleMouseOut () {
    setTooltipDisplayData()
    setFocusedFlow({})
  }

  return (
    <g>
      {svgElements}
    </g>
  )
}
